import { render, staticRenderFns } from "./QualityReciveIcon.vue?vue&type=template&id=52f75712&"
import script from "./QualityReciveIcon.vue?vue&type=script&lang=js&"
export * from "./QualityReciveIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports